import SetupApi from '../api/SetupApi';
import OrganizationApi from '../../../Resources/Organization/OrganizationApi';
import { featureInterests } from './Data';
import { showErrorDialog } from '../../Common/CommonActions';
import Utils from '../../Common/Utils';
import ProgressiveApi from './ProgressiveApi';
import { BOOK_DEMO_ACTIONS } from './BookDemoSchema';
import { updateEntity } from '../../Common/Data/DataFetcherEntitiesHelper';

export const completeProgressiveOnboarding = () => {
  const onboardingEvent = { event: 'update_welcome_page', stage: 'setup' };
  return SetupApi.advanceOnboardingState(onboardingEvent);
};

export const updateInterests = (interests) => OrganizationApi.updateOrganizationInterests(interests);

export const completeOnboardingAndUpdateInterests = (interest) => (dispatch) => {
  Promise.all([completeProgressiveOnboarding(), updateInterests({ interests: featureInterests[interest].value })])
    .then(featureInterests[interest].redirectToLink)
    .catch((error) => {
      dispatch(showErrorDialog(Utils.parseErrorMessage(error)));
    });
};

export const updateCanBookDemo = (dispatch) => {
  ProgressiveApi.updateDemoBooked().then((response) => {
    dispatch(updateEntity('data', { can_book_demo: response.data.can_book_demo }, BOOK_DEMO_ACTIONS));
  });
};
